// extracted by mini-css-extract-plugin
export default {"container":"Practices_container__DtnG6","introBox":"Practices_introBox__mqzbZ","introText":"Practices_introText__67glR"};